module.exports = __webpack_public_path__ + "img/btn_baoqie.ed984f27.png";